(function () {
  function initRecipeLibrary(root) {
    if (!root || root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';

    var selectedFilters = {
      product: 'all',
      flavor: 'all'
    };

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-recipe-card]'));
    var status = root.querySelector('[data-recipe-status]');

    function updateCards() {
      var visibleCount = 0;

      cards.forEach(function (card) {
        var matchesProduct = selectedFilters.product === 'all' || card.dataset.product === selectedFilters.product;
        var matchesFlavor = selectedFilters.flavor === 'all' || card.dataset.flavor === selectedFilters.flavor;
        var isVisible = matchesProduct && matchesFlavor;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (status) {
        var singular = status.dataset.singular || 'recept';
        var plural = status.dataset.plural || 'recept';
        status.textContent = visibleCount + ' ' + (visibleCount === 1 ? singular : plural);
      }
    }

    root.querySelectorAll('[data-filter-group]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.dataset.filterGroup;
        var value = button.dataset.filterValue;

        selectedFilters[group] = value;

        root.querySelectorAll('[data-filter-group="' + group + '"]').forEach(function (groupButton) {
          groupButton.setAttribute('aria-pressed', groupButton === button ? 'true' : 'false');
        });

        updateCards();
      });
    });

    root.querySelectorAll('[data-recipe-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialogId = button.getAttribute('aria-controls');
        var dialog = document.getElementById(dialogId);

        if (!dialog || typeof dialog.showModal !== 'function') return;

        dialog.showModal();
        document.body.classList.add('jarn-recipe-dialog-open');
      });
    });

    root.querySelectorAll('[data-recipe-dialog]').forEach(function (dialog) {
      dialog.addEventListener('close', function () {
        document.body.classList.remove('jarn-recipe-dialog-open');
      });

      dialog.addEventListener('click', function (event) {
        var rect = dialog.getBoundingClientRect();
        var clickedOutside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;

        if (clickedOutside) dialog.close();
      });
    });

    updateCards();
  }

  function initAllRecipeLibraries(scope) {
    (scope || document).querySelectorAll('[data-jarn-recipe-library]').forEach(initRecipeLibrary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllRecipeLibraries(document);
    });
  } else {
    initAllRecipeLibraries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllRecipeLibraries(event.target);
  });
})();
